import { servicesRoute } from './services';

export const allServices = [
    servicesRoute()
];

